module.exports = __webpack_public_path__ + "img/container_img05.abb6d5d4.png";